import { Stack, Typography } from '@mui/material';

import type { PropertyAdInProgressWorkspace } from '../../types/propertyAdEditor';

import { MyButton, MyDialog } from '../uiComponents';

interface ExistingInProgressDialogProps {
  onContinue: (workspace: PropertyAdInProgressWorkspace) => void;
  onStartNew: () => void;
  workspace: PropertyAdInProgressWorkspace;
}

export const ExistingInProgressDialog = ({
  onContinue,
  onStartNew,
  workspace,
}: ExistingInProgressDialogProps) => (
  <MyDialog open dialogTitle='You have an unfinished listing' width='640'>
    <Typography color='#2a3842' component='p' fontWeight={400} lineHeight='24px' textAlign='center'>
      Continue working on it or choose how to start a new listing.
    </Typography>
    <Stack
      alignItems={{ xs: 'stretch', sm: 'center' }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent='center'
      padding='30px 0 10px'
      spacing={2.5}
    >
      <MyButton
        data={{
          buttonName: 'Continue',
          buttonType: 'button',
          customWidth: '180px',
          variant: 'contained',
        }}
        onClick={() => onContinue(workspace)}
      />
      <MyButton
        data={{
          buttonName: 'Start new',
          buttonType: 'button',
          customWidth: '180px',
          styleType: 'cancel',
          variant: 'outlined',
        }}
        onClick={onStartNew}
      />
    </Stack>
  </MyDialog>
);
